
import { Component, Vue, Watch } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';

import formatNumber from '@/shared/filters/format-number';
import Paging from '@/shared/components/Paging.vue';

import { DATA } from '@/config/data';
import { APP_CONFIG } from '@/config/app-config';

import { SummaryDepositModel } from '@/models/summary-deposit';
import { DepositModel } from '@/models/deposit';

import ListDeposit from './components/ListDeposit.vue';
import FilterBox from './components/FilterBox.vue';
import ConfirmModal from '@/shared/components/ConfirmModal.vue';

import depositServices from '@/services/deposit-services';
import SummaryOrder from './components/SummaryOrder.vue';
import authService from '@/services/auth-services';
import commonService from '@/services/common-services';
@Component({
    components: {
        ListDeposit,
        FilterBox,
        Loading,
        Paging,
        ConfirmModal,
        SummaryOrder
    }
})
export default class MainDeposit extends Vue {
    private filterProp = {
        selectedStatus: { value: -1, name: 'Tất cả', color: '#fff' },
        searchText: ''
    };
    private pageSettings = {
        rowPerPage: 15,
        pageSize: 6,
        pageIndex: 1,
        total: 0,
    };
    
    private summaryOrder: SummaryDepositModel = new SummaryDepositModel();
    private listDeposit: DepositModel[] = [];
    private isLoading = false;
    private chinaAddress = '';
    private isConfirm = false;
    private modalContent = 'Bạn có thực sự muốn hủy đơn hàng này không?';
    private showNextConfirm = true;
    private isPayOrder = false;

    private actions = {
        cancel: 'cancel',
        deposit: 'deposit',
        new: 'new',
        pay: 'pay'
    };
    private actionSelected: any = this.actions.cancel;

    zeroPad = (num, places) => String(num).padStart(places, '0');

    get showMenu() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].showMenuLeft;
    }

    get customerInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].customerInfo;
    }

    get totalChoose() {
        return this.listDeposit.filter(x => x.isChecked === true).length;
    }

    get totalChoosePayable() {
        return this.listDeposit.filter(x => x.isChecked === true && x.status === 7).length;
    }

    get amountNeedPay() {
        return this.listDeposit.reduce((amount: number, order: DepositModel) => {
            return amount + (order.isChecked === true && order.status === 7 ? order.totalPriceVND - order.payment : 0)
        }, 0);
    }

    private async getCustomersInfo() {
        const result = await authService.customersInfo(this.customerInfo.ID);
        if(result && result.status === 200) {
            (window['getApp'] as any).$emit('APP_SET_CUSTOMER_INFO', result.data.data || {});
        }
    }

    private async getConfig() {
        const result = await commonService.getDetailChinaStore(this.customerInfo.ChinaStoreID);

        if (result && result.status === 200) {
            this.chinaAddress = `${this.customerInfo.UserCode} - ${result.data.data.Phone} - ${result.data.data.Address}${this.customerInfo.UserCode}`;
        }
    }

    private async created() {
        this.loadData();
    }

    private async onCheckAll(isCheckAll: boolean) {
        this.listDeposit = this.listDeposit.map(x => {
            return {
                ...x,
                isChecked: x.status === 7 ? isCheckAll : x.isChecked
            }
        });
    }

    private async loadData() {
        this.isLoading = true;
        this.pageSettings.total = 0;
        const filters: any = this.onBuildFilter();
        this.summaryOrder = new SummaryDepositModel();
        this.getCustomersInfo();
        this.getConfig();
        const result = await depositServices.getDeposit(this.pageSettings.pageIndex, this.pageSettings.rowPerPage, filters.filters, filters.quickFilters);
        this.isLoading = false;
        if (result && result.data && result.data.status === 200) {
            const tmpListDeposit: DepositModel[] = [];
            this.pageSettings.total = result.data.total;
            this.summaryOrder = {
                TotalStatusAll: result.data.summary.TotalStatusAll || 0,
                TotalStatus1: result.data.summary.TotalStatus1 || 0,
                TotalStatus7: result.data.summary.TotalStatus7 || 0,
                TotalStatus9: result.data.summary.TotalStatus9 || 0,
                TotalStatus10: result.data.summary.TotalStatus10 || 0,
                TotalStatus11: result.data.summary.TotalStatus11 || 0,
                TotalStatus12: result.data.summary.TotalStatus12 || 0,
                TotalStatus16: result.data.summary.TotalStatus16 || 0,
                TotalAmountStoreVN: result.data.summary.TotalAmountStoreVN || 0,
                TotalLeftStoreVN: result.data.summary.TotalLeftStoreVN || 0,
            };

            for (const item of result.data.data) {
                const deposit = new DepositModel();
                deposit.id = item.ID;
                deposit.depositCode = item.DepositCode;
                deposit.uId = item.UID;
                deposit.userName = item.Username;
                deposit.status = item.Status;
                deposit.statusDetail = DATA.depositStatus.find(x => x.value === item.Status) || { value: 0, name: 'Khác', color: '#3b4354' };
                deposit.orderWeight = item.OrderWeight;
                deposit.totalPriceVND = item.TotalPriceVND;
                deposit.payment = item.Payment || 0;
                deposit.createdDate = item.CreatedDate;
                deposit.storeVNExDate = item.StoreVNExDate;
                deposit.storeVNImDate = item.StoreVNImDate;

                tmpListDeposit.push(deposit);
            }
            this.listDeposit = tmpListDeposit;
        }
    }

    private onBuildFilter() {
        const paramsFilter: any = {
            filters: [],
            quickFilters: []
        };
        if (this.filterProp.selectedStatus.value !== -1) {
            paramsFilter.filters.push({
                column: 'Status',
                value: this.filterProp.selectedStatus.value,
                condition: 'equal'
            });
        }

        if (this.filterProp.searchText !== null &&
            this.filterProp.searchText !== undefined &&
            this.filterProp.searchText !== '') {
                paramsFilter.quickFilters.push({
                    column: 'DepositCode',
                    value: this.filterProp.searchText,
                    condition: 'contain'
                });
                paramsFilter.quickFilters.push({
                    column: 'ID',
                    value: this.filterProp.searchText,
                    condition: 'contain'
                });
        }

        return paramsFilter;
    }

    private createNewDeposit() {
        const routeData = this.$router.resolve({ name: 'deposit-new' });
        window.open(routeData.href, '_blank');
    }

    private onFilterChanged(data: any) {
        this.filterProp.selectedStatus = data.status;
        this.filterProp.searchText = data.searchText;
        this.pageSettings.pageIndex = 1;
        this.loadData();
    }

    private onChangePage(data: any) {
        this.pageSettings.pageIndex = data;
        this.loadData();
    }

    private onAcceptModal(eventData: any) {
        this.isConfirm = !eventData.close || false;
        if (eventData.data === 'OK' && this.actionSelected === this.actions.pay) {
            this.submitPayOrder(eventData.shipType, eventData.shipAddress, eventData.shipPhone, eventData.shipNote);
        }
    }

    private onCloseModal(eventData: any) {
        this.isConfirm = !eventData.close || false;
    }

    private async submitPayOrder(shipType, shipAddress, shipPhone, shipNote) {
        this.isLoading = true;
        const dataRequest = {
            'type': 7,
            'shipType': shipType,
            'shipAddress': shipAddress || this.customerInfo.Address,
            'shipPhone': shipPhone || this.customerInfo.PhoneNumber,
            'shipNote': shipNote,
            'ids': this.listDeposit
                    .filter(x => (x.status === 7 || x.status === 9) && x.isChecked === true)
                    .map(x => x.id)
        }
        const result = await depositServices.updateMultiOrder(dataRequest);

        if (result && result.status === 200 && result.data.data.status === true) {
            Vue.notify({group: 'foo',type: 'success',title: 'Thông báo!',text: 'Thanh toán hàng thành công!'});
            this.getCustomersInfo();
            this.loadData();
        } else if (result && result.data.status === 202) {
            Vue.notify({
                group: 'foo',
                type: 'error',
                title: 'Thông báo!',
                text: result.data.error,
            });
            this.isLoading = false;
        } else {
            this.isLoading = false;
        }
    }

    private onModalContentPay(listDeposit: DepositModel[], amountNeedDeposit) {
        let modalContent = `<div class="modal-happy">Bạn có muốn thanh toán cho <span class="fb text-danger">${listDeposit.length}</span> đơn dưới đây không?
                            <div>
                                <ul>`
        for(const order of listDeposit) {
            modalContent += `<li>`;
            modalContent += `<div>[Mã đơn: <span class="fb">${order.id}</span>]<span class="text-danger ml10 fr">${ formatNumber(order.totalPriceVND - order.payment, '0,0') } <i>VND</i></span></div>`
            modalContent += `</li>`;
        }

        modalContent += `<li><div class="text-danger fb">TỔNG TIỀN THANH TOÁN<span class="fb ml10 fr">${ formatNumber(amountNeedDeposit, '0,0') } <i>VND</i></span></div></li>`;

        modalContent += `</ul></div>`;
        

        return modalContent;
    }

    private async onActionStatus(action: any) {
        this.actionSelected = action;
        this.isPayOrder = false;
        if (this.actionSelected !== this.actions.new && this.totalChoose === 0) {
            Vue.notify({group: 'foo',type: 'warn',title: 'Thông báo!',text: 'Không có đơn hàng nào được chọn!'});
            return false;
        }
        switch(this.actionSelected) {
            case this.actions.pay: {
                const countNoWaitPay = this.listDeposit.filter(x => x.status !== 7 && x.status !== 9 && x.isChecked === true).length;
                if (countNoWaitPay > 0) {
                    Vue.notify({group: 'foo',type: 'warn',title: 'Thông báo!',text: 'Chức năng này chỉ dành cho những đơn NHẬP KHO VN!'});
                    return false;
                }
                if (this.customerInfo.Wallet >= this.amountNeedPay) {
                    const listDeposit = this.listDeposit.filter(x => (x.status === 7 || x.status === 9) && x.isChecked === true);
                    this.modalContent = this.onModalContentPay(listDeposit, this.amountNeedPay);
                    this.isConfirm = true;
                    this.isPayOrder = true;
                    this.showNextConfirm = true;
                } else {
                    this.modalContent = `<div style="color: #111;">Số tiền trong ví của bạn không đủ để đặt thanh toán.</div>
                                        <div>Tiền cần thanh toán: <span class="fb">${formatNumber(this.amountNeedPay, '0,0')} VND</span></div>
                                        <div>Ví: <span class="fb">${formatNumber(this.customerInfo.Wallet, '0,0')} VND</span></div>
                                        <div class="text-danger">Hãy nạp tiền để tiếp tục đặt thanh toán!</div>`;
                    this.isConfirm = true;
                    this.showNextConfirm = false;
                }
                break;
            }
            case this.actions.new: {
                const routeData = this.$router.resolve({ name: 'order-new' });
                window.open(routeData.href, '_blank');
            }  
        }
    }
}
